import React from "react";
import PostForm from "../PostForm";
import * as S from "./CreatePostModule.styles.";
interface Props {
  onPostCreated?: () => void;
  project_id?: number;
}

const CreatePostModule: React.FC<Props> = ({ onPostCreated, project_id }) => {
  return (
    <S.CenteredContainer>
      <PostForm onPostCreated={onPostCreated} project_id={project_id} />
    </S.CenteredContainer>
  );
};

export default CreatePostModule;

